const cancelReasonApiErrorMappings = {
  reason: {
    'value is not unique': 'Sudah terdaftar di sistem.'
  }
}

export default cancelReasonApiErrorMappings
